import { render } from "./BrowseSection.vue?vue&type=template&id=91eae734&scoped=true"
const script = {}

import "./BrowseSection.vue?vue&type=style&index=0&id=91eae734&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91eae734"]])

export default __exports__